import { AtomKey } from '../_constants';
import { atom } from 'recoil';

export const BingeState = atom<boolean>({
  key: AtomKey.BINGE,
  default: false,
});
